module.exports = __webpack_public_path__ + "static/media/gpvnl-background-full-gradient.3e21a564.jpg";